import { getUserInitials } from 'utils/avatar';
import useUserAvatar from './useUserAvatar';
import './ActivityParticipant.css';

export default function ActivityParticipant({ user, meeting, avatarOnly = false }) {
  const { avatarSrc, onAvatarError, displayUser } = useUserAvatar(user, meeting);
  const name = `${displayUser?.firstName || ''} ${displayUser?.lastName || ''}`.trim() || 'TBA';

  return (
    <span className="activity-participant" aria-label={avatarOnly ? name : undefined}>
      {avatarSrc
        ? <img className="activity-participant-avatar" src={avatarSrc} alt="" onError={onAvatarError} />
        : <span className="activity-participant-initials" aria-hidden="true">{getUserInitials(displayUser, 'T')}</span>}
      {!avatarOnly && <span>{name}</span>}
    </span>
  );
}
